import React from 'react';

import BooksList from './BooksList';

const DashboardPage = () => {
    return <BooksList />;
};

export default DashboardPage;
